<template>
    <div class="bg-white">
        <nav class="sub-sub-menu-nav border-b border-secondary">
            <ul class="sub-sub-menu">
                <li class="sub-sub-menu-time">
                    <router-link
                        class="sub-sub-menu-item-link"
                        :to="{ name: 'SiteAdminTrainersIndex' }"
                        @click.prevent.stop="gotoRoute({ name: 'SiteAdminTrainersIndex' })"
                    >
                        <IconTrainer class="w-6 h-6 mr-2" />
                        Trainers</router-link
                    >
                </li>
                <li class="sub-sub-menu-time">
                    <router-link
                        class="sub-sub-menu-item-link"
                        :to="{ name: 'SiteAdminTrainersVirtualGroups' }"
                        @click.prevent.stop="gotoRoute({ name: 'SiteAdminTrainersVirtualGroups' })"
                    >
                        <IconCourse class="w-6 h-6 mr-2 text-green-700" />
                        Upcoming {{ $t("Virtual Groups") }}</router-link
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
export default {
    methods: {
        gotoRoute(route) {
            this.$router.push(route);
            this.$store.commit("closeMobileMenu");
        }
    }
};
</script>